export default function validate(values, name) {
  let errors = {};

  if (!values.email) {
    errors.email = 'Please fill in required information.';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Email address is invalid';
  } 
  if (!values.firstName) {
    errors.firstName = 'FirstName is required';
  } 
  if (!values.surName) {
    errors.surName = 'SurName is required'; ;
  } 

  return errors;
};